import MOCKED_INVOICES from "./finance/invoice-list";
import MOCKED_PAYROLL from "./finance/payroll";

export const MOCKED_FINANCE_STATE = {
  invoices: MOCKED_INVOICES,
  payroll: MOCKED_PAYROLL
};
